import cx from 'classnames';
import { Checkbox } from 'react-aria-components';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import styles from '../styles.module.css';

const PrivacySection = () => {
  const intl = useIntl();

  return (
    <div className={styles.privacySection}>
      <Checkbox
        isRequired={true}
        className={cx('react-aria-Checkbox', styles.checkboxContainer)}
        name="privacy-policy"
      >
        <div className={styles.checkbox}>
          <svg viewBox="0 0 18 18" aria-hidden="true">
            <polyline points="1 9 7 14 15 4" />
          </svg>
        </div>
        <span>
          <FormattedMessage
            {...messages.privacy_policy_field_label}
            values={{
              privacyLink: (
                <UniversalLink href="/privacy-policy" openLinkInNewTab={true}>
                  Privacy Policy
                </UniversalLink>
              ),
            }}
          />
        </span>
      </Checkbox>

      <Checkbox
        className={cx('react-aria-Checkbox', styles.checkboxContainer)}
        name="privacy-marketing"
      >
        <div className={styles.checkbox}>
          <svg viewBox="0 0 18 18" aria-hidden="true">
            <polyline points="1 9 7 14 15 4" />
          </svg>
        </div>
        <span>
          <FormattedMessage
            {...messages.marketing_field_label}
            values={{
              privacyLink: (
                <UniversalLink href="/privacy-policy" openLinkInNewTab={true}>
                  Privacy Policy
                </UniversalLink>
              ),
            }}
          />
        </span>
      </Checkbox>

      <Checkbox
        className={cx('react-aria-Checkbox', styles.checkboxContainer)}
        name="privacy-data-analysis"
      >
        <div className={styles.checkbox}>
          <svg viewBox="0 0 18 18" aria-hidden="true">
            <polyline points="1 9 7 14 15 4" />
          </svg>
        </div>
        <span>
          <FormattedMessage
            {...messages.data_field_label}
            values={{
              privacyLink: (
                <UniversalLink href="/privacy-policy" openLinkInNewTab={true}>
                  Privacy Policy
                </UniversalLink>
              ),
            }}
          />
        </span>
      </Checkbox>
    </div>
  );
};

export default PrivacySection;

const messages = defineMessages({
  privacy_policy_field_label: {
    id: 'privacy_policy_field_label',
    defaultMessage: 'I have read and understood the {privacyLink} *',
  },
  marketing_field_label: {
    id: 'marketing_field_label',
    defaultMessage:
      'I  would like to receive news and updates from QubicaAMF (see “Marketing” purpose as defined in the {privacyLink})',
  },
  data_field_label: {
    id: 'data_field_label',
    defaultMessage:
      'I consent to the analysis of my data and interests, also to receive from QubicaAMF personalized information most appropriate to my needs (see "Profiling" purpose as defined in the {privacyLink})',
  },
});
